// removed by extract-text-webpack-plugin
module.exports = {"content":"kqO28jgojDwGi1_cq28G-","body":"_21GS37d4QvW-3HtHjK8Zs4"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/src/MessageBox/MessageBoxFunctionalLayout.scss
// module id = ./node_modules/wix-style-react/src/MessageBox/MessageBoxFunctionalLayout.scss
// module chunks = 0